import { render } from "./scorecard-display-settings.vue?vue&type=template&id=7b4a6b7c&ts=true"
import script from "./scorecard-display-settings.vue?vue&type=script&lang=ts"
export * from "./scorecard-display-settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__